export const SMS_CHARACTER_LIMIT = 160;

export const validateSMSSettings = (settings) => {
  const errors = {};

  // Validate notifications object
  if (!settings.notifications) {
    errors.notifications = 'Notifications settings are required';
  } else {
    const requiredNotifications = ['bookingConfirmation', 'appointmentReminders', 'schedulingUpdates', 'pendingConfirmationRequest', 'checkInLinkRequest'];
    requiredNotifications.forEach(notification => {
      if (typeof settings.notifications[notification] !== 'boolean') {
        errors.notifications = errors.notifications || {};
        errors.notifications[notification] = `${notification} setting must be a boolean`;
      }
    });
  }

  if (
    settings.pendingConfirmationUseReply !== undefined &&
    typeof settings.pendingConfirmationUseReply !== 'boolean'
  ) {
    errors.pendingConfirmationUseReply = 'Must be a boolean';
  }

  // Validate templates
  if (!settings.templates) {
    errors.templates = 'Templates are required';
  } else {
    const requiredTemplates = ['bookingConfirmation', 'appointmentReminder', 'scheduleChange', 'pendingConfirmationRequest', 'checkInLinkRequest'];
    requiredTemplates.forEach(template => {
      if (!settings.templates[template]) {
        errors.templates = errors.templates || {};
        errors.templates[template] = `${template} template is required`;
      } else {
        // Validate template content
        if (!settings.templates[template].content || typeof settings.templates[template].content !== 'string') {
          errors.templates = errors.templates || {};
          errors.templates[template] = `${template} template content is required and must be a string`;
        } else if (settings.templates[template].content.length > SMS_CHARACTER_LIMIT) {
          errors.templates = errors.templates || {};
          errors.templates[template] = `${template} template must be ${SMS_CHARACTER_LIMIT} characters or less`;
        }
      }
    });
  }

  // Validate reminders
  if (settings.reminderEnabled) {
    if (!Array.isArray(settings.reminders)) {
      errors.reminders = 'Reminders must be an array';
    } else if (settings.reminders.length === 0) {
      errors.reminders = 'At least one reminder is required when reminders are enabled';
    } else if (settings.reminders.length > 3) {
      errors.reminders = 'Maximum of 3 reminders allowed';
    } else {
      const validHours = [24, 48, 72, 96, 120, 144, 168, 192, 216, 240, 264, 288, 312, 336];
      const invalidHours = settings.reminders.filter(hours => !validHours.includes(hours));
      if (invalidHours.length > 0) {
        errors.reminders = `Invalid reminder timing values: ${invalidHours.join(', ')}. Valid values are: ${validHours.join(', ')}`;
      }
    }
  } else {
    // If reminders are disabled, ensure reminders array exists and is empty
    if (!Array.isArray(settings.reminders)) {
      errors.reminders = 'Reminders must be an array';
    }
  }

  return errors;
};

export const validatePhoneNumber = (phoneNumber) => {
  // Basic phone number validation - can be enhanced based on requirements
  const phoneRegex = /^\+?[1-9]\d{1,14}$/;
  return phoneRegex.test(phoneNumber);
}; 